// components/PageViewTracker.tsx
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from 'utils/constants';
import { matchRoute } from 'utils/routeFunction';
import { getSessionStorageItem } from 'utils/sessionFunctions';

export default function PageViewTracker() {
  const location = useLocation();
  const sessionId = getSessionStorageItem('session_id');

  useEffect(() => {
    const { pathname, search, state: locationState } = location;

    // update global context/tags
    Sentry.setTag('current_route', pathname);
    if (search) Sentry.setTag('current_search', search);

    Sentry.withScope((scope) => {
      scope.setContext('route', {
        pathname,
        search,
        state: locationState,
        sessionId,
        timestamp: new Date().toISOString()
      });
    });

    // add breadcrumb
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: `Page viewed: ${pathname}`,
      data: {
        search,
        state: locationState,
        referrer: document.referrer,
        sessionId
      },
      level: 'info'
    });

    // match route for logging/debugging
    const routeMatch = matchRoute(pathname, ROUTES);
    if (routeMatch) {
      Sentry.setTag('matched_route_key', routeMatch.key);
    }
  }, [location, sessionId]);

  return null;
}
